<template>
  <a class='btn fat' :href="calculatorLink()" target="_blank">Oblicz ratę w banku BNP Paribas</a>
</template>

<script>
    export default {
        name: "InstallmentCalculator",
      props: {
        price: Number
      },
      data() {
          return {
            agreementNo: 2202471,

          }
      },
      methods: {
          calculatorLink() {
            let base = "https://irata.bgzbnpparibas.pl/eshop-form/calc";
            return `${base}?RequestedAmount=${this.price}&AgreementNo=${this.agreementNo}&CreditType=${this.installmentsCode()}`;
          },
        installmentsCode() {

          if (this.price >= 5999) return "131122;131120;100110";
          if (this.price >= 2999) return "131120;100110";
          return "100110";
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Products/InstallmentCalculator.vue